// extracted by mini-css-extract-plugin
export default {"text_popup":"ErrorsPopup_text_popup__D-0+-","button":"ErrorsPopup_button__KklkB"};